<template>
  <div class="container container-vende-tu-auto">
    <div class="row justify-content-center">

      <div class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center">
        <img class="step-desktop" src="../assets/imgs/desktop/vende_tu_auto_documentos_web.png" alt="AUTOCOM" />
        <img class="step-tablet" src="../assets/imgs/tablet/vende_tu_auto_documentos_tablet.png" alt="AUTOCOM" />
        <img class="step-mobile" src="../assets/imgs/mobile/vende_tu_auto_documentos_mobile.png" alt="AUTOCOM" />
      </div>

      <div class="container container-info ">
        <div class="container-vende-view">
          <div class="content-va">
            <div class="text-center">

              <p class="instruccion-1" style="font-weight: bold;">¿Quieres vender tu auto y no sabes qué documentos
                tienes que entregar?</p>
              <p class="instruccion-2">Te compartimos un listado de ellos para que los tomes en cuenta.</p>

              <div class="row">
                <div class="col-md-6 col-sm-12 ">
                  <div class="card" style="text-align: left;">
                    <h5 class="card-header tituloDocumentacion">Persona física</h5>
                    <div class="card-body">

                      <h5 class="tituloDocumentacion">Propietario del vehículo:</h5>
                      <ul>
                        <li class="documentacion">INE</li>
                        <li class="documentacion">Comprobante de domicilio</li>
                        <li class="documentacion">Carátula del estado de cuenta para pago del vehículo</li>
                      </ul>

                      <h5 class="tituloDocumentacion">Vehículo:</h5>
                      <ul>
                        <li class="documentacion">Factura original (si es el único dueño)</li>
                        <li class="documentacion">Refactura con copia de la original (si tiene más dueños)</li>
                        <li class="documentacion">Alta de placas</li>
                        <li class="documentacion">Refrendos</li>
                        <li class="documentacion">Tenencias (si aplica)</li>
                        <li class="documentacion">Verificaciones</li>
                        <li class="documentacion">Baja de placas (si ya se realizó)</li>
                      </ul>

                      <h5 class="tituloDocumentacion">Para recibir una mejor oferta tu vehículo deberá contar con:</h5>
                      <ul>
                        <li class="documentacion">Manuales</li>
                        <li class="documentacion">Duplicado de llaves</li>
                        <li class="documentacion">Refacción y herramientas del vehículo</li>
                      </ul>

                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-sm-12  modelo">
                  <div class="card" style="text-align: left;">
                    <h5 class="card-header tituloDocumentacion">Persona moral o persona física con actividad empresarial
                    </h5>
                    <div class="card-body">
                      <h5 class="tituloDocumentacion">Propietario del vehículo:</h5>
                      <ul>
                        <li class="documentacion">INE</li>
                        <li class="documentacion">Constancia de situación fiscal</li>
                        <li class="documentacion">Comprobante de domicilio con dirección de la constancia de situación
                          fiscal</li>
                        <li class="documentacion">Carátula del estado de cuenta para pago del vehículo</li>
                        <li class="documentacion">Acta constitutiva (solo para persona moral)</li>
                      </ul>

                      <h5 class="tituloDocumentacion">Vehículo:</h5>
                      <ul>
                        <li class="documentacion">Factura original (si es el único dueño)</li>
                        <li class="documentacion">Refactura emitida por la PM o PFAE</li>
                        <li class="documentacion">Refactura con copia de la original (si tiene más dueños)</li>
                        <li class="documentacion">Alta de placas</li>
                        <li class="documentacion">Refrendos</li>
                        <li class="documentacion">Tenencias (si aplica)</li>
                        <li class="documentacion">Verificaciones</li>
                        <li class="documentacion">Baja de placas (si ya se realizó)</li>
                      </ul>

                      <h5 class="tituloDocumentacion">Para recibir una mejor oferta tu vehículo deberá contar con:</h5>
                      <ul>
                        <li class="documentacion">Manuales</li>
                        <li class="documentacion">Duplicado de llaves</li>
                        <li class="documentacion">Refacción y herramientas del vehículo</li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>


              <button class="btn-regresar" @click.prevent="regresar()">REGRESAR</button>

              <p class="tituloDocumentacion" style="margin-top: 25px;">¿No cuentas con algún documento?</p>
              <p class="documentacion" style="margin-top: -10px;">Visítanos con la documentación que tengas, nosotros te
                ayudamos, contamos con personal capacitado que puede asesorarte y brindarte apoyo.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "Documentos",

  components: {

  },


  data() {
    return {


    };
  },

  methods: {

    regresar(){
      let prev=sessionStorage.getItem("prev")
      setTimeout(() => {
        // window.open('/Documentos');
        switch(prev){
          case 'vendedor':
            this.$router.push({ path: "/Vendedor" });
            break;
          case 'vehículo':
            this.$router.push({ path: "/" });
            break;
          case 'inspeccion':
            this.$router.push({ path: "/Inspeccion" });
            break;
          case 'oferta':
            this.$router.push({ path: "/Oferta" });
            break; 

        }
        //this.$router.go(-1);
      }, 150);
    }

  },
  
  watch: {

  },

  created() {
    window.scrollTo(0,0);
  },

  onMounted(){
    window.scrollTo(0, 0)
  }
};

</script>

<style>

</style>